import React from 'react'
import PropTypes from 'prop-types'
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup'

import './Splash.scss'

const Splash = ({ title, logo, image, isVisible }) => {

  return (
    <CSSTransitionGroup
      transitionName='ou_splash'
      transitionEnterTimeout={1600}
      transitionLeaveTimeout={1500}
    >
      {isVisible && <div className='ou_scene ou_splash' key='splash'>
        <div className='ou_splash__bg-bottom' style={{ backgroundImage: `url(${image})` }} />
        <div className='ou_splash__bg' style={{ backgroundImage: `url(${image})` }} />
        <div className='ou_splash__bg-color' />
        <div id='ou_splash__logo' className='ou_splash__logo' style={{ backgroundImage: `url(${logo})` }} />
        <div id='ou_splash__title' className='ou_splash__title'><span className='ou_splash__title--text'>{ title }</span></div>
        <div className='ou_splash__logo-powered' />
      </div>}
    </CSSTransitionGroup>
  )
}

Splash.propTypes = {
  title: PropTypes.string,
  logo: PropTypes.string,
  image: PropTypes.string,
  isVisible: PropTypes.bool
}

export default Splash



// WEBPACK FOOTER //
// ./src/templates/outSide/components/scenes/Splash.js